export default {"src":"/_next/static/media/linkedin.e58f5550.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};